import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
  enableProdMode,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LicenseManager } from 'ag-grid-enterprise';

import {
  AgGridLicence,
  setQzTrayLicense,
  AuthService,
  ConfigService,
  LoadingInterceptor,
  ClickGuardService,
  LanguageService,
  ThemeService,
  TmsLibModule,
  AuthModule,
  registerLocales,
  SystemEnvironmentService,
} from 'tms-lib';
import { TmsWebGridService, TmsWebTranslationService } from 'tms-web-shared';
import { environment } from './environments/environment';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      BrowserModule,
      AppRoutingModule,
      TmsLibModule,
      AuthModule.forRoot(),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.production,
        // Register the ServiceWorker as soon as the app is stable
        // or after 30 seconds (whichever comes first).
        registrationStrategy: 'registerWhenStable:30000',
      }),
    ),
    provideAppInitializer(() => {
      // Marks the tab title and icon of a TEST / DEV system; does nothing on Live.
      inject(SystemEnvironmentService).applyToDocument();

      // One guard against double clicks for every button in the app.
      inject(ClickGuardService).start();

      const authService = inject(AuthService);
      const gridService = inject(TmsWebGridService);
      const translationService = inject(TmsWebTranslationService);
      const configService = inject(ConfigService);
      const themeService = inject(ThemeService);

      registerLocales();

      // Adopt the appearance index.html already applied from localStorage, so the service and the
      // page agree before the first screen renders. The user's saved preference is read once they
      // are authenticated (LoginMenuComponent).
      themeService.applyStored();

      authService.homeRoute = 'Home';
      gridService.load();
      translationService.load();
      return configService.load();
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: localStorage.getItem(LanguageService.LanguageKey) ?? LanguageService.DefaultLanguage,
    },
  ],
}).catch((err) => console.error(err));

LicenseManager.setLicenseKey(AgGridLicence);

setQzTrayLicense();
